// eslint-disable-next-line no-restricted-syntax
import {
	createPropertiesSchema,
	videoBackgroundProperties,
	mediaContainerDesignSchema,
} from '@wix/thunderbolt-components-native/dist/core'
import * as yup from 'yup'

export const designSchema = mediaContainerDesignSchema

export const propertiesSchema = createPropertiesSchema(
	'PopupContainerProperties',
	yup
		.object({
			horizontalAlignment: yup.mixed<'left' | 'center' | 'right'>().default('center'),
			verticalAlignment: yup.mixed<'top' | 'center' | 'bottom'>().default('top'),
			alignmentType: yup.mixed<'nineGrid' | 'fullHeight' | 'fullWidth'>().default('nineGrid'),
			horizontalOffset: yup.number().default(0),
			verticalOffset: yup.number().default(0),
		})
		.concat(videoBackgroundProperties)
)
